import type { ReactNode } from 'react';

import { Box } from '@mui/material';

export const DrawerBody = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      p: 3,
      flex: 1,
      overflow: 'auto'
    }}
  >
    {children}
  </Box>
);
